/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestProgressionMilestone
 */
export interface QuestProgressionMilestone {
    /**
     * 
     * @type {string}
     * @memberof QuestProgressionMilestone
     */
    milestoneId: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestProgressionMilestone
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    claimedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    amount: number;
    /**
     * Lifetime high-water mark for streak progress
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    bestAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgressionMilestone
     */
    sessionAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestProgressionMilestone
     */
    gameId?: string;
    /**
     * Checkpoint thresholds that have been reached
     * @type {Array<number>}
     * @memberof QuestProgressionMilestone
     */
    completedCheckpoints?: Array<number>;
    /**
     * Checkpoint thresholds whose rewards have been claimed
     * @type {Array<number>}
     * @memberof QuestProgressionMilestone
     */
    claimedCheckpoints?: Array<number>;
}

/**
 * Check if a given object implements the QuestProgressionMilestone interface.
 */
export function instanceOfQuestProgressionMilestone(value: object): value is QuestProgressionMilestone {
    if (!('milestoneId' in value) || value['milestoneId'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function QuestProgressionMilestoneFromJSON(json: any): QuestProgressionMilestone {
    return QuestProgressionMilestoneFromJSONTyped(json, false);
}

export function QuestProgressionMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestProgressionMilestone {
    if (json == null) {
        return json;
    }
    return {
        
        'milestoneId': json['milestoneId'],
        'isComplete': json['isComplete'],
        'claimedAt': json['claimedAt'] == null ? undefined : json['claimedAt'],
        'amount': json['amount'],
        'bestAmount': json['bestAmount'] == null ? undefined : json['bestAmount'],
        'sessionAmount': json['sessionAmount'] == null ? undefined : json['sessionAmount'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'completedCheckpoints': json['completedCheckpoints'] == null ? undefined : json['completedCheckpoints'],
        'claimedCheckpoints': json['claimedCheckpoints'] == null ? undefined : json['claimedCheckpoints'],
    };
}

export function QuestProgressionMilestoneToJSON(json: any): QuestProgressionMilestone {
    return QuestProgressionMilestoneToJSONTyped(json, false);
}

export function QuestProgressionMilestoneToJSONTyped(value?: QuestProgressionMilestone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'milestoneId': value['milestoneId'],
        'isComplete': value['isComplete'],
        'claimedAt': value['claimedAt'],
        'amount': value['amount'],
        'bestAmount': value['bestAmount'],
        'sessionAmount': value['sessionAmount'],
        'gameId': value['gameId'],
        'completedCheckpoints': value['completedCheckpoints'],
        'claimedCheckpoints': value['claimedCheckpoints'],
    };
}

